import React from 'react';
import io from 'socket.io-client'



let appName =  "local"//process.env.REACT_APP_SOCKET_NAME;


switch(process.env.REACT_APP_BASE_URL) {
    case "https://epfdlw-api.gtoken.in/":
        appName = "epfdlw";
        break;
    case "https://nnk-api.gtoken.in/":
        appName = "nnk";
        break;
    case "https://nnynr-api.gtoken.in/":
        appName = "nnynr";
        break;
    case "https://nnpkl-api.gtoken.in/":
        appName = "nnpkl";
        break;
    case "https://hc-api.gtoken.in/":
        appName = "hc";
        break;
    case "https://demo-api.gtoken.in/":
        appName = "demo";
        break;
    case "http://localhost:8000/":
        appName = "local";
        break;
}


//appName = "local";


export const socket = io.connect("https://tms-notification.gtoken.in?app="+appName);
export const SocketContext = React.createContext();